/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * The label is used as the caption. In relational terms it defines a new row, based on other rows. In Olap terms it defines a new member, based on other members. E.g. kitchen_furniture = [table] + [chair], YOY_difference = [2016] - [2015]. <p>Java class for calculatedMemberType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="calculatedMemberType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="expression" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class CalculatedMemberType extends ObjectType{

	expression = null;



	/**
	 * Gets the value of the expression property.
	 * @return {String} possible object is {@link String}
	 */
	getExpression() {
		return this.expression;
	}

	/**
	 * Sets the value of the expression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExpression(value) {
		var oldValue = this.expression;
		this.expression = value;
		this._setAndNotify(5, oldValue, value, false, true);
	}

	/**
	 * Creates a new instance of <code>CalculatedMemberType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> CalculatedMemberType</code> object from.
	 * @return {CalculatedMemberType} an object of type <code>CalculatedMemberType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createCalculatedMemberType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "CalculatedMemberType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 5, "expression", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 5:
			this.setExpression((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 5:
			return this.getExpression();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 5:
			return this.getExpression();
		default:
			return super.basicGet(featureID);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/CalculatedMemberType.js